import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { OnzoeLogo } from '../brand/OnzoeLogo';

const footerGroups = [
  {
    title: 'Solutions',
    links: [
      { label: 'Website Voice Agent', to: '/ai-agents' },
      { label: 'Use Cases', to: '/solutions' },
      { label: 'Beta Reporting', to: '/analytics' },
    ],
  },
  {
    title: 'Company',
    links: [
      { label: 'About', to: '/about' },
      { label: 'Blog', to: '/blog' },
      { label: 'Careers', to: '/careers' },
    ],
  },
  {
    title: 'Support',
    links: [
      { label: 'Contact', to: '/contact' },
      { label: 'Documentation', to: '/docs' },
      { label: 'System Status', to: '/status' },
    ],
  },
  {
    title: 'Legal',
    links: [
      { label: 'Privacy', to: '/privacy' },
      { label: 'Terms', to: '/terms' },
      { label: 'Security', to: '/security' },
    ],
  },
]

export const Footer: React.FC = () => {
  return (
    <footer className="relative overflow-hidden border-t border-[#20D9FF]/18 bg-[#F5F7FA] text-[#05070D] dark:bg-[#05070D] dark:text-white">
      <div className="absolute inset-0">
        <img
          src="/images/onzoe-hero.png"
          alt=""
          aria-hidden="true"
          className="h-full w-full object-cover opacity-18"
        />
        <div className="absolute inset-0 bg-[#F5F7FA]/90 dark:bg-[#05070D]/90" />
      </div>

      <div className="relative mx-auto max-w-7xl px-4 py-12 sm:px-6 lg:px-8 lg:py-16">
        <div className="grid gap-10 lg:grid-cols-[1.05fr_1.95fr]">
          <div>
            <OnzoeLogo className="h-auto w-44 text-[#05070D] dark:text-white" />
            <p className="mt-5 max-w-sm text-sm leading-7 text-[#4C5965] dark:text-white/62">
              Voice agents and narrated product experiences that make intelligence present—and show what it changes.
            </p>
            <Link
              to="/beta"
              className="mt-7 inline-flex items-center rounded-md bg-[#FFB454] px-5 py-3 text-sm font-black text-[#05070D] transition-colors hover:bg-[#ffc579] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#147A95] dark:focus-visible:ring-[#20D9FF]"
            >
              Request beta access
              <ArrowRight className="ml-2 h-4 w-4" aria-hidden="true" />
            </Link>
          </div>

          <div className="grid gap-8 sm:grid-cols-2 lg:grid-cols-4">
            {footerGroups.map((group) => (
              <div key={group.title}>
                <h3 className="text-xs font-bold uppercase tracking-[0.22em] text-[#147A95] dark:text-[#20D9FF]">
                  {group.title}
                </h3>
                <ul className="mt-5 space-y-3">
                  {group.links.map((link) => (
                    <li key={link.to}>
                      <Link
                        to={link.to}
                        className="rounded-sm text-sm font-medium text-[#4C5965] dark:text-white/62 transition-colors hover:text-[#05070D] dark:hover:text-white focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#147A95] dark:focus-visible:ring-[#20D9FF]"
                      >
                        {link.label}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-12 flex flex-col gap-3 border-t border-[#05070D]/10 dark:border-white/10 pt-6 text-xs text-[#4C5965] dark:text-white/62 sm:flex-row sm:items-center sm:justify-between">
          <p>&copy; {new Date().getFullYear()} Onzoe. All rights reserved.</p>
          <p className="uppercase tracking-[0.18em]">Voice · tours · proof</p>
        </div>
      </div>
    </footer>
  );
};
